<template>
  <div class="list-root">
    <div v-if="result">
      <div class="item-wrap" v-for="item in type === 'amounts' ? result.amount_records : result.credit_records " :key="item.pk">
        <div>
          <Icon v-if="item.amounts < 0" class-prefix="icon iconfont iconjianhao" />
          <Icon v-else class-prefix="icon1 iconfont icon21" />
        </div>
        <div class="main" style="flex:1;">
          <div class="notes">{{item.notes}}</div>
          <div class="time">{{ formatDate(item.datetime_created) }}</div>
        </div>
        <div class="number">
          {{type === 'amounts' ? item.amounts : item.credits}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api,http } from 'utils/'
import Cookies from 'js-cookie'
import moment from 'moment'
import { Dialog } from 'vant';
export default {
  data() {
    return {
      result:null,
      type:''
    }
  },
  created() {
    let { query:{type} } = this.$route
    this.type = type
    document.title = type === 'amounts' ? '余额变更记录' : '积分变更记录'
    if(this.getToken()) {
      this.getUserInfo()
    }else{
      Dialog.alert({
        title: '提示',
        message: '请先登录'
      }).then(() => {
        this.$router.push('/profile')
      })
    }
  },
  methods:{
    async getUserInfo() {
      const res = await http({
        url:api.getUserInfo,
        headers: {
          'content-type': 'application/json',
          "Authorization": `Bearer ${this.getToken()}`
        }
      })
      if(res) {
        this.result = res
        console.log(res)
      }
    },
    setToken(token) {
      Cookies.set('JWT', token, { expires: 1 })
    },
    getToken() {
      const token = Cookies.get('JWT')
      if (token) return token
      else return false
    },
    formatDate(date) {
      return moment(date).format("YYYY年MM月DD日") 
    }
  }
}
</script>

<style lang="less" scoped>
.list-root{
  padding: 0 0;
  height: 100%;
  overflow: auto;
  // background: #fff;
  .item-wrap{
    padding: 16px;
    background: #ffffff;
    position: relative;
    // margin-bottom: 12px;
    display: flex;
    &::before{
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      height: 2px;
      background: -webkit-repeating-linear-gradient(135deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
      background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
      background-size: 80px;
      content: ''
    }
    .icon{
      font-size: 40px;
      color: #ff6c6c;
    }
    .icon1{
      font-size: 40px;
      color: #0abb06;
    }
    .notes{
      font-size: 16px;
      margin-bottom: 8px;
    }
    .time{
      font-size: 14px;
    }
    .main{
      padding: 12px;
    }
    .number{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
    }
  }
}
</style>